import { PageHeader } from '@/components/shell/page-header';
import { createFileRoute } from '@tanstack/react-router';
import { BarChart3, MousePointerClick, Send, TrendingUp } from 'lucide-react';

export const Route = createFileRoute('/_authed/analytics')({ component: AnalyticsPage });

function AnalyticsPage(): React.JSX.Element {
  return (
    <div className="space-y-8">
      <PageHeader
        title="Analytics"
        description="Understand delivery, engagement, and conversion across mobile experiences."
      />
      <section className="border-y py-14">
        <div className="mx-auto max-w-3xl">
          <div className="text-center">
            <span className="mx-auto grid size-11 place-items-center rounded-lg border bg-secondary/50">
              <BarChart3 className="size-5" />
            </span>
            <div className="mt-4 flex items-center justify-center gap-2">
              <h2 className="text-base font-semibold">Reporting is not connected yet</h2>
              <span className="rounded border px-1.5 py-0.5 text-[9px] font-semibold uppercase text-muted-foreground">Planned</span>
            </div>
            <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-muted-foreground">
              This page reserves the reporting workspace without inventing data. It will activate when the event analytics pipeline is ready.
            </p>
          </div>
          <div className="mt-8 grid gap-3 sm:grid-cols-3">
            <MetricPlaceholder icon={Send} label="Delivered" />
            <MetricPlaceholder icon={MousePointerClick} label="Engaged" />
            <MetricPlaceholder icon={TrendingUp} label="Converted" />
          </div>
        </div>
      </section>
    </div>
  );
}

function MetricPlaceholder({ icon: Icon, label }: { icon: typeof Send; label: string }): React.JSX.Element {
  return (
    <div className="rounded-lg border p-4">
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium text-muted-foreground">{label}</span>
        <Icon className="size-4 text-muted-foreground" />
      </div>
      <div className="mt-5 h-2 w-20 rounded bg-secondary" />
      <div className="mt-2 h-2 w-12 rounded bg-secondary" />
    </div>
  );
}

